<template>
  <span v-if="value" :class="phoneType && 'gu-datagrid-multi-line'">
    {{ formattedNumber }}
    <span v-if="phoneType" class="gu-datagrid-cell-unit">
      {{ phoneType }}
    </span>
  </span>
  <span v-else-if="emptyValueText" :class="[emptyValueClass || 'gu-datagrid-empty-value']">
    {{ emptyValueText }}
  </span>
</template>

<script setup>
const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const {
  value,
  data,
  //
  format,
  type,
  emptyValueText,
  emptyValueClass,
} = props.params

const rawNumber = value.replace(/\D+/g, '')
const formattedNumber = rawNumber.replace(/(\d{3})(\d{3})(\d{4})/, format || '($1) $2-$3')
const phoneType = data[type]
</script>
